module.exports = function() {
	var list = [];
	list.toString = function toString() {
		var result = [];
		for(var i = 0; i < this.length; i++) {
			var item = this[i];
			if(item[2]) {
				result.push("@media " + item[2] + "{" + item[1] + "}");
			} else {
				result.push(item[1]);
			}
		}
		return result.join("");
	};
	return list;
}


/*****************
 ** WEBPACK FOOTER
 ** (webpack)/~/css-loader/cssToString.js
 ** module id = 2
 ** module chunks = 0
 **/